import { Box, Flex } from '@chakra-ui/react';
import React from 'react';
import { colors } from '../theme/colors';
import { Body } from './Texts/Texts';

interface TabsProps {
  tabs: string[];
  activeTab: string;
  tabAction: any;
}

export const Tabs = ({ tabs, activeTab, tabAction }: TabsProps) => {
  return (
    <Flex>
      {tabs.map((tab, index) => {
        const isActive = tab === activeTab;
        const isLast = index === tabs.length - 1;
        return (
          <Box
            onClick={() => tabAction(tab)}
            pb='4px'
            borderBottom={`2px solid ${
              isActive ? colors.deep_blue : colors.gray_50
            }`}
            mr={isLast ? '0px' : '32px'}
            cursor='pointer'
            key={tab + index}
          >
            <Body
              size='14px'
              fontWeight={700}
              textTransform='capitalize'
              color={isActive ? 'deep_blue' : 'gray'}
            >
              {tab}
            </Body>
          </Box>
        );
      })}
    </Flex>
  );
};

interface TabsProps {
  tabs: string[];
  activeTab: string;
  tabAction: any;
  centered?: boolean;
}

export const BlockTabs = ({
  tabs,
  activeTab,
  tabAction,
  centered
}: TabsProps) => {
  return (
    <Flex justifyContent={centered ? 'center' : 'flex-start'} gap='8px'>
      {tabs.map((tab, index) => {
        const isActive = tab === activeTab;
        return (
          <Box
            onClick={() => tabAction(tab)}
            py='8px'
            px='16px'
            border={`1px solid ${isActive ? colors.dark_green : '#e2e8f0'}`}
            bg={isActive ? colors.dark_green : 'white'}
            borderRadius='8px'
            cursor='pointer'
            key={tab + index}
            _hover={{
              bg: isActive ? colors.dark_green : 'gray.50',
              borderColor: isActive ? colors.dark_green : colors.deep_blue,
              transform: 'translateY(-1px)'
            }}
            transition='all 0.2s ease'
            boxShadow={isActive ? '0 2px 4px rgba(0, 0, 0, 0.1)' : '0 1px 2px rgba(0, 0, 0, 0.05)'}
          >
            <Body
              size='13px'
              fontWeight={600}
              textTransform='capitalize'
              color={isActive ? 'white' : 'gray.600'}
            >
              {tab}
            </Body>
          </Box>
        );
      })}
    </Flex>
  );
};

export default Tabs;
